var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 75C58.9607 75 75.75 58.2107 75.75 37.5C75.75 16.7893 58.9607 0 38.25 0C17.5393 0 0.75 16.7893 0.75 37.5C0.75 58.2107 17.5393 75 38.25 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 50.5435L25.2067 72.6679C29.269 74.1753 33.6631 75 38.2501 75C54.3736 75 68.1192 64.8235 73.4175 50.5435H21.9458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 24.4566L25.2067 2.33218C29.269 0.824707 33.6631 0 38.2501 0C54.3736 0 68.1192 10.1766 73.4175 24.4566H21.9458Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 37.5C0.75 53.6237 10.9267 67.3691 25.2066 72.6676V2.33252C10.9267 7.631 0.75 21.3764 0.75 37.5Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/flagUnitedArabEmirates.15f21dd7c86e424127aa0d3f9c25527e.svg";
export { ForwardRef as ReactComponent };